import { State } from 'reducers';
import { createSelector } from 'reselect';
import { HasDeviceId } from './buildingsSelectors';

const getDeviceId = (state: State, { deviceId }: Partial<HasDeviceId>) => deviceId;

const getDeviceEventsState = (state: State) => state.deviceEvents;

export const getDeviceEvents =
    createSelector(
        getDeviceEventsState,
        getDeviceId,
        (state, deviceId) => (deviceId && state.data[deviceId]) || null
    );

export const getDeviceEventsLoading =
    createSelector(
        getDeviceEventsState,
        getDeviceId,
        (state, deviceId) => !!(deviceId && state.loading[deviceId])
    );

export const getDeviceEventsHasMore =
    createSelector(
        getDeviceEventsState,
        getDeviceId,
        (state, deviceId) => !!(deviceId && state.hasMore[deviceId])
    );

export const getDeviceEventsError =
    createSelector(
        getDeviceEventsState,
        state => state.error
    );
